export default "__VITE_ASSET__CIzcv0Bh__"